

import * as rpc from "@/constants/rpc";
import Jd from "@/models/jd";
import code from "@/utils/code";
import empty from "@/mixins/empty";
import {E_NOT_FOUND} from "@/constants/err";

export default {
    mixins: [empty],
    data() {
        return {
            q: "",
            experience: "",
            degree: "",
            salary: "",
            stage: "",
            scale: "",
            industry: "",

            jds: [],
            pageCurrent: 1,
            pageSize: 20,
            total: 0,
        };
    },
    computed: {
        isLoadDataEmpty() {
            return !this.jds || this.jds.length==0
        },
        asideCompanies() {
            let companies = []
            let obj = {}
            for (let i=0;i<this.jds.length;i++) {
                // 去重：利用对象访问属性的方法，判断对象中是否存在key
                let c = this.jds[i]?.company
                if(!obj[c._id]){
                    companies.push(c);
                    obj[c._id] = true;
                }
                // 只要前两个不同的
                if (companies.length >= 2) {
                    break
                }
             }
            return companies
        }
    },
    created() {
        this.q = this.$route.query?.q ?? "";
        console.log("===="+this.q)
        this.searchJds()
    },
    watch: {
        // q:function (newValue,oldValue) {
        //     console.log("q="+newValue)
        //     if (newValue != this.q) {
        //         this.searchJds()
        //     }
        // },
        experience:function (newValue,oldValue) {
            console.log("experience="+newValue)
            this.searchJds()
        },
        degree:function (newValue,oldValue) {
            console.log("degree="+newValue)
            this.searchJds()
        },
        salary:function (newValue,oldValue) {
            console.log("salary="+newValue)
            this.searchJds()
        },
        stage:function (newValue,oldValue) {
            console.log("stage="+newValue)
            this.searchJds()
        },
        scale:function (newValue,oldValue) {
            console.log("scale="+newValue)
            this.searchJds()
        },
        industry:function (newValue,oldValue) {
            console.log("industry="+newValue)
            this.searchJds()
        },
        pageCurrent:function (newValue,oldValue) {
            console.log("pageCurrent="+newValue)
            this.searchJds()
        }
    },
    methods: {
        onSearch(value) {
            console.log("onSearch="+value + ",q="+this.q)
            this.q = value
            this.searchJds()
        },
        async searchJds() {
            this.loaded = false
            let params = {
                pageNum: this.pageCurrent,
                pageSize: this.pageSize,
                q: this.q,
                experienceId: code.toInt(this.experience),
                degreeId: code.toInt(this.degree),
                salaryId: code.toInt(this.salary),
                stageId: code.toInt(this.stage),
                scaleId: code.toInt(this.scale),
                industryId: code.toInt(this.industry),
            }
            params.industryId2 = params.industryId
            params.industryId3 = params.industryId
            const ret = await this.$axios.rpcMsg(rpc.SEARCH, rpc.SEARCH_JDS, params, [E_NOT_FOUND])
            if (ret && ret.result) {
                this.total = ret.result.count
                if (ret.result.jds) {
                    let newArray = []
                    for (let i=0;i<ret.result.jds.length;i++) {
                        let jd = new Jd(ret.result.jds[i])
                        newArray.push(jd)
                    }
                    this.jds = newArray
                    this.loaded = true
                } else {
                    this.jds = []
                    this.loaded = true
                }
            } else {
                this.jds = []
                this.loaded = true
            }
        },

    }
}

